var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 1.32812C6.75 0.90625 7.45312 0.90625 7.875 1.32812L11.9531 5.40625L16.0781 1.32812C16.5 0.90625 17.2031 0.90625 17.625 1.32812C18.0938 1.79688 18.0938 2.5 17.625 2.92188L15.0469 5.5H20.25C22.3125 5.5 24 7.1875 24 9.25V21.25C24 23.3594 22.3125 25 20.25 25H3.75C1.64062 25 0 23.3594 0 21.25V9.25C0 7.1875 1.64062 5.5 3.75 5.5H8.90625L6.32812 2.92188C5.85938 2.5 5.85938 1.79688 6.32812 1.375V1.32812ZM3.75 7.75C2.90625 7.75 2.25 8.45312 2.25 9.25V21.25C2.25 22.0938 2.90625 22.75 3.75 22.75H20.25C21.0469 22.75 21.75 22.0938 21.75 21.25V9.25C21.75 8.45312 21.0469 7.75 20.25 7.75H3.75ZM19.5 10.375C20.1094 10.375 20.625 10.8906 20.625 11.5C20.625 12.1562 20.1094 12.625 19.5 12.625C18.8438 12.625 18.375 12.1562 18.375 11.5C18.375 10.8906 18.8438 10.375 19.5 10.375ZM18.375 15.25C18.375 14.6406 18.8438 14.125 19.5 14.125C20.1094 14.125 20.625 14.6406 20.625 15.25C20.625 15.9062 20.1094 16.375 19.5 16.375C18.8438 16.375 18.375 15.9062 18.375 15.25ZM6.75 10H14.25C15.4688 10 16.5 11.0312 16.5 12.25V18.25C16.5 19.5156 15.4688 20.5 14.25 20.5H6.75C5.48438 20.5 4.5 19.5156 4.5 18.25V12.25C4.5 11.0312 5.48438 10 6.75 10Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.91e62d5c349127dcad9ef21ef63e7cee.svg";
export { ForwardRef as ReactComponent };